module.exports = __webpack_public_path__ + "img/answer.d3a591e2.png";